export default (state, getters, rootState, rootGetters) => {
    if(!rootGetters['dictionary/paymentOperation/getById'](state.form.PaymentOperationID)) return false;
    return rootGetters['dictionary/paymentOperation/getById'](state.form.PaymentOperationID).OperationType;
}